const Selectors = {
  classes: {
    variantButton: '.single-option-selector',
    defaultSelectorsWrapper: '.product-form__default-controls-group .selector-wrapper',
    allProductsSelectors: '.product-option__item-select',
    allPropertiesInputs: '.product-option__item-input input',
    orderNotes: '.product-options__item-textarea textarea',
    form: 'form.product-form',
    buyNowButton: '.checkout-btn',
    productOptionItem: '.product-options__item',
    productOptionItemError: '.product-options__item.error',
    productCheckboxItem:'.group-of-checkboxes',
    productCheckboxItemError: '.group-of-checkboxes.error',
    relatedProductWrapper: '.related_products_wrapper',
    relatedProductSelect: '.related_products-select',
    relatedProductCheckbox: '.related_products-checkbox input',
    relatedVariantsSelect: '.related_variants-select select',
    relatedVariantImageWrap: '.related_variants-image',
    adaptorModelSelect: '.adaptor-model-value',
    adaptorModelOption: '.adaptor-model-option',
    propertiesOptionsSelect: '.properties_options-select select',
    propertiesOptionsRadio: '.product-options__checkbox-content input',
    requiredCheckboxSelect: '.product-options__checkbox-group-wrapper input',
    multipleCheckboxSelect: '.default-checkboxes.product-group_checkbox-wrapper input',
    stockCheckboxes: '.group-of-stock-checkboxes input',
    formProperties: '.form_selected_properties',
    submitLoadingButton: '.product-form__cart-submit',
    priceHolder: 'span[data-variant-price]',
    colorSwatch: '.color-swatch',
    clubQuantity: '.club-quantity',
    clubValue: '.club-value',
    singleProductSelect: '.single-product select',
    mainPrice: '.price-item',
    variantOptions: 'select.product-form__variants',
    quantityInput: '.quantity-num',
    quantityBtns: '.input-group-button [data-field="quantity"]',
    groupOfChecbxes: '.group-of-checkboxes',
    stockClubNumbers: '.stock-club-numbers select',
    customizeActive: '.customize.active',
    optionsContainer: '.product-options__container',
    customizedProduct: '.toggle-container',
    currencySymbol: 'localization-form .localization-form__button'
  },

  relatedProductIds: [],
  relatedProductsObj: {},
  propertiesObj: { ["_main_group_key"]: Date.now() },
  clubCheckboxes: [],
  stockActive: false,
  stockQuantity: 0,

  buildPropertiesObject: function(target){
    if(target.name && target.name != '' && target.value ) {
      Selectors.propertiesObj = {
        ...Selectors.propertiesObj,
        [target.name]: target.value
      }
    }
  },
  buildPropertiesInputs: function(){
    console.log('buildPropertiesInputs', Selectors.propertiesObj)
    const formProperties = document.querySelector(this.classes.formProperties);
    const inputsArray = [];

    for (const [key, value] of Object.entries(Selectors.propertiesObj)) {
      if(key && value != 0 ) {
        inputsArray.push(`<input type="hidden" name="properties[${key}]" value="${value}">`)
      }
    }

    formProperties.innerHTML = inputsArray.map(input => input).join('');
  },
  buildRelatedProductIds: function() {
    Selectors.relatedProductIds = [];
    Selectors.relatedProductsObj = {};
    let price = null;

    const activeTabContent = document.querySelector('.toggle-content.active');
    if(activeTabContent) {
    activeTabContent.querySelectorAll(this.classes.relatedVariantsSelect).forEach(select => {
      price = select.options[select.selectedIndex].dataset.variantPrice;
      txt = select.options[select.selectedIndex].text;

      if ( select.value == 'stock') {
      } else {
        if (!txt.includes('No ')) {
          Selectors.relatedProductIds.push(select.value);
        }
        if (![null, undefined].includes(price)) {
          Selectors.relatedProductsObj[select.value] = price;
        }
      }
    });

    activeTabContent.querySelectorAll(this.classes.requiredCheckboxSelect).forEach(checkbox => {
      price = checkbox.dataset.variantPrice;
      Selectors.relatedProductIds.push(checkbox.checked.value);
      if (![null, undefined].includes(price) && checkbox.checked) {
        Selectors.relatedProductsObj[checkbox.value] = price;
      }
    });

    activeTabContent.querySelectorAll(this.classes.relatedProductCheckbox).forEach(checkbox => {
      price = checkbox.dataset.variantPrice;
      if (![null, undefined].includes(checkbox) && checkbox.checked) {
        Selectors.relatedProductIds.push(checkbox.value);
        Selectors.relatedProductsObj[checkbox.value] = price;
      }
    });

    }
    Selectors.relatedProductIds = Selectors.relatedProductIds.filter(id => id);
  },
  onRelatedVariantsChange: function() {
    document.querySelectorAll(this.classes.relatedVariantsSelect).forEach(select => {
      const notValidGrips = ['Golf Pride MCC Black White Align Standard',
                            'Golf Pride MCC Black White Align Midsize',
                            'Golf Pride MCC Plus 4 Gray Align Standard',
                            'Golf Pride MCC Plus 4 Gray Align Midsize',
                            'Golf Pride Tour Velvet Align Standard',
                            'Golf Pride Tour Velvet Align Midsize',
                            'Golf Pride Z-Grip Cord Align Standard',
                            'Golf Pride Z -Grip Cord Align Midsize']

      select.addEventListener('change', function(e){
        const txt = select.options[select.selectedIndex].text;
        notValidGrips.some(element => {
          if (txt.includes(element)) {
            $('.checkbox-logo label[for="Down"]').css('display','none');
            return true;
          }
          $('.checkbox-logo label[for="Down"]').css('display','flex');
          return false;
        });
      })
    })
  },
  onRelatedProductChange: function(){
    document.querySelectorAll(this.classes.relatedProductSelect).forEach(select => {
      select.addEventListener('change', function(e){
        Selectors.getRelatedProductVariants(e.target.value, e.target)
        Selectors.changePrice();
      })

      function handleChange(e) {
        Selectors.getRelatedProductVariants(e.target.value, e.target);
        Selectors.changePrice();
      }
      handleChange({ target: select });
      window.addEventListener('load', handleChange);

    })
  },
  onRelatedVariantChange: function(){
    document.querySelectorAll(this.classes.relatedVariantsSelect).forEach(select => {
      select.addEventListener('change', function(e){
        const parent = select.parentElement.parentElement.parentElement.parentElement;
        console.log(parent, 'parent')
        if(parent.classList.contains('related_products_wrapper')){
          $(parent.querySelector('.customize .related_variants-image')).slideDown('slow')
        }
        if (!e.target.value) return
        Selectors.removeError(e.target);
        Selectors.showVariantImage(e.target.value, e.target);
        Selectors.buildRelatedProductIds();
        Selectors.changePrice();
      })
    });
  },
  onPropertieSelectChange: function() {
    document.querySelectorAll(this.classes.propertiesOptionsSelect).forEach(select => {

      select.addEventListener('change', function(e) {
        console.log(Selectors.stockActive, 'STOCK')
        if (!e.target.value) return;
        Selectors.removeError(e.target);
        Selectors.buildPropertiesObject(e.target);
        Selectors.changePrice();

      });

      if(document.querySelector(this.classes.customizeActive) != null) {
        if (select.value) {
          Selectors.removeError(select);
          Selectors.buildPropertiesObject(select);
        }
      }

    });
  },
  onPropertieInputChange: function(){
    document.querySelectorAll(this.classes.allPropertiesInputs).forEach(input => {
      input.addEventListener('keyup', function(e){
        if (!e.target.value) return
        Selectors.buildPropertiesObject(e.target);
      })
    })
  },
  onPropertiesAreaChange: function() {
    document.querySelectorAll(this.classes.orderNotes).forEach(textarea => {
    textarea.addEventListener('keyup', function (e) {
      if (!e.target.value) return

      Selectors.buildPropertiesObject(e.target);
    })
    })
  },
  onSelectAdaptorModelChange: function(){
    $('.adaptor-settings-value').prop('disabled', true);
    $(".adaptor-settings-value").html("<option>Choose Option</option>");
    $(".adaptor-variant-mark").hide();
    $('.adaptor-model-value').change(function() {
      $(".adaptor-settings-value").html("");
      $(".adaptor-variant-help").html("");
      let newOptions =  $('.adaptor-model-value :selected').data("settings");
      let helpText = $('.adaptor-model-value :selected').data("variant-help");
      if(helpText != undefined ) {
        $(".adaptor-variant-mark").show();
        $(".adaptor-variant-help").append(helpText);
      } else {
        $(".adaptor-variant-mark").hide();
      }
      for (let i=0; i<newOptions.length; i++) {
          $(".adaptor-settings-value").append("<option>"+newOptions[i]+"</option>");
      }
      $('.adaptor-settings-value').prop('disabled', false);
      Selectors.buildPropertiesObject($('.adaptor-settings-value')[0]);
  });
  },
  onPropertieRadioChange: function(){
    document.querySelectorAll(this.classes.propertiesOptionsRadio).forEach(radio => {
      radio.addEventListener('change', function(e){
        if (!e.target.value) return

        Selectors.removeError(e.target);
        Selectors.buildRelatedProductIds();
        Selectors.buildPropertiesObject(e.target);
      })
    })
  },
  onRequiredCheckboxChange: function(){
    document.querySelectorAll(this.classes.requiredCheckboxSelect).forEach(radio => {
      radio.addEventListener('change', function(e){
        if (!e.target.value) return

        Selectors.removeError(e.target, '.product-options__checkbox-group-wrapper');
        Selectors.buildRelatedProductIds();
        Selectors.changePrice();
      })
    })
  },
  onProductCheckboxChange: function(){
    document.querySelectorAll(this.classes.relatedProductCheckbox).forEach(radio => {
      radio.addEventListener('change', function(e){
        if (!e.target.value) return

        Selectors.removeError(e.target, '.product-options__checkbox-group-wrapper');
        Selectors.buildRelatedProductIds();
        Selectors.changePrice();
      })
    })
  },
  hideImagesByAlt: function(altValue) {
    if(!altValue) return;
    const thumbnails = document.querySelectorAll('.product-slider-nav .image__dots');
    const sliderContainer = document.querySelector('.product-slider-nav');
    const loader = document.querySelector('.loader');

    loader? loader.style.display = 'block' : null

    setTimeout(() => {
      thumbnails.forEach(thumbnail => {
        const slide = thumbnail.closest('.swiper-slide');
        if (thumbnail.getAttribute('alt') === altValue) {
          slide.style.display = '';
        } else {
          slide.style.display = 'none';
        }
      });

      loader.style.display = 'none';
      sliderContainer.style.opacity = '1';
    }, 0);
  },
  onColorsChangeSlides: function(){
    document.querySelectorAll('.color-swatch').forEach(checkbox => {
      checkbox.addEventListener('change', function (e) {
        let selected_variant = $('[name="id"]').val();
        let slider = $('.product-slider .swiper-wrapper .img');
        const thumbnails = document.querySelectorAll('.product-slider-nav .image__dots');
        thumbnails.forEach(thumbnail => {
          const slide = thumbnail.closest('.swiper-slide');
          const altValue = thumbnail.getAttribute('alt');

            if (altValue && altValue === e.target.value) {
              slide.style.display = '';
            } else {
              slide.style.display = 'none';
            }

        });

        const current_url = document.querySelector('.form_selected_properties').dataset.url;
        window.history.replaceState({}, '', `${current_url}?variant=${selected_variant}`);
        let current_variant = Array.from(slider).findIndex(item => item.getAttribute('data-variant-id').split(',').includes(selected_variant));
        document.variantImageSlider.slideTo(current_variant, 1000, false);
      });
    });
  },
  onStockCheckboxChange :function(){
    const radioButtons = document.querySelectorAll(this.classes.stockCheckboxes);

    radioButtons.forEach((radioButton, index) => {
      radioButton.addEventListener('change', function(e) {

        Selectors.validGroupOfCheckboxes();
        Selectors.validGroupOfChecked();
        Selectors.changePrice();
        if (e.target.checked) {
          Selectors.clubCheckboxes = [e.target.value];
        }

        radioButtons.forEach((otherRadioButton, otherIndex) => {
          if (otherIndex !== index) {
            otherRadioButton.checked = false;
          }
        });
      });

      if (index === 0) {
        radioButton.checked = true;
      }
    });
  },
  onMultipleCheckboxChange: function(){
    document.querySelectorAll(this.classes.multipleCheckboxSelect).forEach(checkbox => {
      checkbox.addEventListener('change', function(e){
        const checkedCount = Selectors.clubCheckboxes.length;
        if (e.target.checked){
          Selectors.clubCheckboxes.push($(this).val());
        } else {
          Selectors.clubCheckboxes.splice($.inArray($(this).val(), Selectors.clubCheckboxes), 1);
        }

        Selectors.validGroupOfCheckboxes();
        Selectors.validGroupOfChecked();
        Selectors.changePrice();
      })
    })
  },
  calculateMultipleCheckboxes: function() {
    if (document.querySelector('[data-template="iron-template"] .toggle-content.stock.active')) {
      const stockCheckboxValues = [];
      document.querySelectorAll(this.classes.stockCheckboxes).forEach(checkbox => {
        if (checkbox.checked && !stockCheckboxValues.includes(checkbox.value)) {
          stockCheckboxValues.push(checkbox.value);
        }
      });
      Selectors.clubCheckboxes = stockCheckboxValues;
    } else {
      const multipleCheckboxValues = [];
      document.querySelectorAll(this.classes.multipleCheckboxSelect).forEach(checkbox => {
        if (checkbox.checked && !multipleCheckboxValues.includes(checkbox.value)) {
          multipleCheckboxValues.push(checkbox.value);
        }
      });
      Selectors.clubCheckboxes = multipleCheckboxValues;
    }
  },
  toggleContent: function () {
      const elements = document.querySelectorAll(".toggle-btn");
      const checkboxesWrapper = document.querySelector(this.classes.productCheckboxItem)
      elements.forEach(element => {
        element.addEventListener('click', () => {
        element.click();
        Selectors.clearInputs();
        Selectors.removeError(checkboxesWrapper);
        Selectors.buildRelatedProductIds();
        Selectors.calculateMultipleCheckboxes()
        Selectors.onPropertieSelectChange()

        });
      });
  },
  clearInputs: function () {
    setTimeout(() => {
      const elements = document.querySelectorAll(".customize .product-option__item-select");
      const customizeImages = document.querySelectorAll(".customize .related_variants-image");
      const radioButtons = document.querySelectorAll(".radio-button")
      const variantSelects = document.querySelectorAll('.customize .related_variants-select select')
      const stockRadioButtons = document.querySelectorAll(".toggle-content.stock .circle-checkbox")
      const editedCheckboxes = document.querySelector('.product-options__container').dataset.edited
      const quantityField =  document.querySelector(this.classes.quantityInput)

      if(quantityField) {
        quantityField.value = 1;
      }

      Selectors.buildRelatedProductIds();
      Selectors.calculateMultipleCheckboxes()
      Selectors.onPropertieSelectChange()
      Selectors.changePrice();

      customizeImages.forEach(elem => {
        elem.style.display = 'none'
      })

      variantSelects.forEach(select => {
        const parentClasses = select.parentElement.parentElement.classList;
        if (!parentClasses.contains('single-product') && !parentClasses.contains('ferrule-select')) {
          select.innerHTML = '';
          select.disabled = true;
          const chooseOption = Object.assign(document.createElement('option'), { text: 'CHOOSE', value: '', selected: true, disabled: true });
          select.appendChild(chooseOption);
          select.options[0].disabled = true;
          select.options[0].selected = true;
        } else {
          select.options[0].selected = true;
        }
      });


      elements.forEach(elem => {
        let hasSelectedOption = false;
        for (let i = 0; i < elem.options.length; i++) {
          if (elem.options[i].selected) {
            hasSelectedOption = true;
            break;
          }
        }

        if (!hasSelectedOption || !elem.options[0].selected) {
          let hasStandartOption = false;
          for (let j = 0; j < elem.options.length; j++) {
            if (elem.options[j].textContent.toUpperCase().includes("STANDARD")) {
              elem.options[j].selected = true;
              hasStandartOption = true;
              break;
            }
          }

          if (!hasStandartOption) {
            elem.options[0].selected = true;
          }
        }

      });

      for (let i = 0; i < stockRadioButtons.length; i++) {
        const radio = stockRadioButtons[i];

        if (!radio.disabled) {
            radio.checked = true;
            break;
        }
    }

      if(editedCheckboxes) {
        radioButtons.forEach((radio) => {
          if (!radio.getAttribute('data-checked')) {
            radio.checked = false;
          }
        });
      } else {
        radioButtons.forEach((radio, index) => {
          radio.checked = (index === 0);
        })
      }

  }, 0)
  },
  getRelatedProductVariants: function(value, target){
    if (!value) return

    fetch(`/products/${value}.js`)
      .then(response => response.json())
      .then(data => {
        console.log(data, 'data PRODUCTS')
        if(target){
          Selectors.buildRelatedProductVariants(data, target);
          Selectors.removeError(target);
          Selectors.changePrice(data);
        }
      })
      .catch((error) => {
        if(target){
          const errorMsg = `Error: ${error}`;
          Selectors.showError(target, errorMsg);
        }
      })
  },
  changePrice: function(){

    const customizedProduct = document.querySelector(this.classes.customizedProduct)
    const clubNumbersExist = document.querySelector(this.classes.groupOfChecbxes)

    let price = parseInt(document.querySelector(this.classes.priceHolder).dataset.variantPrice);
    let selectedCheckboxes = 0;
    Selectors.stockQuantity = 0;

    if (document.querySelector('.stock.active')) {
      Selectors.stockActive = true
    } else {
      Selectors.stockActive = false
    }

      for (const [key, value] of Object.entries(Selectors.relatedProductsObj)) {
        price  += parseInt(value);
      }

    document.querySelectorAll(this.classes.multipleCheckboxSelect).forEach(checkbox => {
      if(checkbox.checked) {
        ++selectedCheckboxes
      }
    })
    document.querySelectorAll(this.classes.stockCheckboxes).forEach(checkbox => {
      if (checkbox.checked) {
        Selectors.stockQuantity = parseInt(checkbox.dataset.quantity);
      }
    });

    if (!Selectors.stockActive && customizedProduct && clubNumbersExist && selectedCheckboxes !== 0) {
      document.querySelectorAll(this.classes.priceHolder).forEach(priceHolder => {
        priceHolder.dataset.summPrices = price * selectedCheckboxes;
        priceHolder.innerHTML = Shopify.formatMoney(price * selectedCheckboxes, `${document.querySelector(this.classes.currencySymbol).getAttribute('valid-symbol')} {{amount}}`);
      });
    } else {
      if(Selectors.stockActive && customizedProduct && clubNumbersExist) {
        document.querySelectorAll(this.classes.priceHolder).forEach(priceHolder => {
            priceHolder.dataset.summPrices = price * Selectors.stockQuantity;
            priceHolder.innerHTML = Shopify.formatMoney(price * Selectors.stockQuantity, `${document.querySelector(this.classes.currencySymbol).getAttribute('valid-symbol')} {{amount}}`);
        });
      } else {
        document.querySelectorAll(this.classes.priceHolder).forEach(priceHolder => {
            priceHolder.dataset.summPrices = price;
            priceHolder.innerHTML = Shopify.formatMoney(price,  `${document.querySelector(this.classes.currencySymbol).getAttribute('valid-symbol')} {{amount}}`);
        })
      }
    }
    // updatePriceCurrencySymbols ()
    if(window.breadCreateButtons){window.breadCreateButtons()}
  },
  buildClubsCheckboxes: function() {
    const checkedCount = Selectors.clubCheckboxes.length
    if(checkedCount <= 0) return
    if (document.querySelector('[data-template="iron-template"] .toggle-content.stock.active')) {
      document.querySelector(this.classes.clubQuantity).value = Selectors.stockQuantity;
    } else {
      document.querySelector(this.classes.clubQuantity).value = checkedCount;
    }
  },
  buildClubNumberValue: function () {
    const clubNumbers = Selectors.clubCheckboxes;
    const clubValueWrap = document.querySelector(this.classes.clubValue)
    if (clubValueWrap != null) {
      if (clubNumbers <= 0 ) {
        clubValueWrap.remove()
      } else {
        clubValueWrap.value = clubNumbers;
      }
    }
  },
  updateMainProductProperty: function (mainGroupProductKey, redirectUrl) {
    const data = {
      properties: {
        ...Selectors.propertiesObj,
        _main_group_product: mainGroupProductKey ? mainGroupProductKey : true
      },
      id: document.querySelector('.product-form__variants').value,
      quantity: Selectors.stockActive ? Selectors.stockQuantity : (Selectors.clubCheckboxes.length === 0 ? 1 : Selectors.clubCheckboxes.length)
    }

    fetch(`/cart/change.js`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(response => response.json())
      .then(() => {
        Selectors.loading(false);
        console.log( data, 'data')
        console.log('redirect to', redirectUrl);
        Selectors.clearInputs()
        Selectors.cartCount()
      })
      .catch((error) => {
        Selectors.loading(false);
        console.log('error', error);
      }).finally(
        fetch(`${Shopify.routes.root}cart?sections=cart-drawer`).then(function(response) {
          return response.json()
        })
        .then( function(response) {
            document.querySelector('cart-drawer').renderCartHtml(response);
        })
      )
  },
  buildRelatedProductVariants: function(product, target){
    if (!product) return;
    const symbol = document.querySelector(this.classes.currencySymbol);
    const variants = product.variants;
    let firstVariant = null;

    if(variants.length > 0){
      firstVariant = variants[0].id;
      const parent = target.closest(this.classes.relatedProductWrapper);
      const select = parent.querySelector(this.classes.relatedVariantsSelect);
      select.innerHTML = '';

      const options = variants.map(variant => {
      const validSymbol = symbol.getAttribute('valid-symbol');
      const formattedPrice = Shopify && Shopify.formatMoney(variant.price, `${validSymbol} {{amount}}`);
      const result = `${variant.title} (+${formattedPrice})`;
        return (`<option class="product-variant" data-variant-price="${variant.price}" value="${variant.id}">
          ${result}
        </option>`)
      }).join('');
      select.innerHTML = options;
      select.removeAttribute("disabled");
      select.value = firstVariant;
      select.dispatchEvent(new Event("change"));
    }
  },
  showVariantImage: function(variant, target){
    const parent = target.closest(this.classes.relatedProductWrapper);
    if(!parent || !variant) return

    const variantImagesWrap = parent.querySelector(this.classes.relatedVariantImageWrap);
    const variantImages = variantImagesWrap.querySelectorAll('img.variant-img');

    variantImages.forEach(image => {
      if (image.dataset.variantId !== variant ) {
        image.style.display = 'none';
      } else {
        image.style.display = 'block';
        if( variantImagesWrap.querySelector('div')) {
        variantImagesWrap.querySelector('div').style.display = 'none';
       }
      }
    });
  },
  loading: function(enable){
    const submitButtons = document.querySelectorAll(this.classes.submitLoadingButton);

    submitButtons.forEach(submitButton => {
      const buyNowSubmitButton = submitButton.querySelector(this.classes.buyNowButton);

      if (enable) {
        submitButton.querySelector('.spinner').classList.remove('hide');
        submitButton.disabled = true;

        if (buyNowSubmitButton) {
          buyNowSubmitButton.querySelector('.spinner').classList.remove('hide');
          buyNowSubmitButton.disabled = true;
        }
      } else {
        submitButton.querySelector('.spinner').classList.add('hide');
        submitButton.disabled = false;

        if (buyNowSubmitButton) {
          buyNowSubmitButton.querySelector('.spinner').classList.add('hide');
          buyNowSubmitButton.disabled = false;
        }
      }
    });
  },
  cartCount: function(){
    fetch(`${Shopify.routes.root}cart.js`, { credentials: 'same-origin' })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      cartCount = [];
      cart.items.forEach(function(element){
        if(element.properties && element.properties._main_group_product){
          cartCount.push(element.quantity)
        }
      });

      const cartCountElement = document.querySelector('.header__icon--cart');
      const cartCountElements = document.querySelector('.header__icon--cart .cart-count-bubble');
      const count = document.querySelector('.cart-basket-count');

      function animateCountChange() {
        cartCountElement.animate([
          { transform: 'scale(1)'},
          { transform: 'scale(1.3)' },
          { transform: 'scale(1)' }
        ], {
          duration: 1000,
          iterations: 1
        });
      }

      if (cartCount.length > 0) {
        animateCountChange();
        cartCountElements.classList.remove('hidden')
        count.innerHTML = cartCount.reduce((a, b) => a + b);
      } else {
        cartCountElements.classList.add('hidden')
      }

    })
  },
  addToCartButton: function(){
    const defaultSubmitButton = document.querySelectorAll(this.classes.submitLoadingButton);
    const buyNowSubmitButton = document.querySelector(this.classes.buyNowButton);

    document.querySelector(this.classes.form).addEventListener('submit', function(e){
      e.preventDefault()
    });

    defaultSubmitButton.forEach(el => {el.addEventListener('click', function(e){
      console.log('DEFAULT BUTTON');
      Selectors.addToCart();
    });})

    if(buyNowSubmitButton != null) {
    buyNowSubmitButton.addEventListener('click', function(e){
      console.log('QUICK BUY');
      Selectors.addToCart('/checkout');
    });
    }
  },
  addToCart: function(redirectUrl = '/cart'){
    if (!Selectors.validate()) return
      console.log('Validation passed.');

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

      Selectors.buildPropertiesInputs();
      Selectors.buildClubsCheckboxes();
      Selectors.buildClubNumberValue();
      Selectors.loading(true);

      jQuery.ajax({
        type: 'POST',
        url: `${Shopify.routes.root}cart/add.js`,
        data: $(Selectors.classes.form).serialize(),
        // data: $(this).serialize(),
        dataType: 'json',
        success: function(res) {
          Selectors.loading(false);
          const mainGroupProductKey = res.key
          if (Selectors.relatedProductIds.length > 0) {
            Selectors.addToCartRelatedProducts(mainGroupProductKey, redirectUrl);
            Selectors.clearInputs()
          }
          Selectors.clearInputs()

            fetch(`${Shopify.routes.root}cart?sections=cart-drawer`).then(function(response) {
              return response.json()
            })
            .then( function(response) {
                document.querySelector('cart-drawer').renderCartHtml(response);
            })

          Selectors.cartCount()

        },
        error: function(error){
          Selectors.loading(false);
          if (error?.responseJSON?.description) {
            alert(error.responseJSON.description)
            console.log('error', error.responseJSON.description);
          }
        }
      });
  },

  // addToCart: function (redirectUrl = '/cart') {
  //   if (!Selectors.validate()) return;
  //   console.log('Validation passed.');

  //   const cartDrawer = document.querySelector('cart-drawer');
  //   if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

  //   Selectors.buildPropertiesInputs();
  //   Selectors.buildClubsCheckboxes();
  //   Selectors.buildClubNumberValue();
  //   Selectors.loading(true);

  //   const formData = new FormData($(Selectors.classes.form)[0]);
  //   if (cartDrawer) {
  //     formData.append(
  //       'sections',
  //       cartDrawer.getSectionsToRender().map((section) => section.id)
  //     );
  //     formData.append('sections_url', window.location.pathname);
  //     cartDrawer.setActiveElement(document.activeElement);
  //   }

  //   const config = fetchConfig('javascript');
  //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
  //   delete config.headers['Content-Type'];
  //   config.body = formData;

  //   fetch(`${routes.cart_add_url}`, config)
  //   .then((response) => response.json())
  //   .then((response) => {

  //     fetch('/cart.js', { credentials: 'same-origin' })
  //     .then(function(response) {
  //       return response.json();
  //     })
  //     .then(function(cart) {
  //       console.log(cart,'cart.dasdasda')
  //       });
  //     const mainGroupProductKey = response.key;

  //     if (Selectors.relatedProductIds.length > 0) {
  //       Selectors.addToCartRelatedProducts(mainGroupProductKey, redirectUrl);
  //     }

  //     Selectors.clearInputs();

  //   })
  //   .catch((e) => {
  //     console.error(e);
  //   })
  // },

  addToCartRelatedProducts: function(mainGroupProductKey, redirectUrl){
    const data = {
      items: []
    }
    Selectors.relatedProductIds.forEach(id => {
      const relatedProductType = document.querySelector(`.related_variants-select .product-option__item-select [value="${id}"]`)

      const sstSelect = document.querySelector(`.single-product [value="${id}"]`)

      let myPropertiesObj = {
        _additional_product: mainGroupProductKey? mainGroupProductKey:true
      }

      if (relatedProductType != null) {

      const Parent = relatedProductType.closest('.option__wrapper__two-items')

       myPropertiesObj._adstype = Parent != null ?
                                  Parent.querySelector('select[product-with-ads]').options[Parent.querySelector('select[product-with-ads]').selectedIndex].dataset.adsType:
                                  '';
      }
      myPropertiesObj._main_group_key =
      Selectors.propertiesObj["_main_group_key"];

 	  if ( sstSelect ) {
        myPropertiesObj._adstype = sstSelect.dataset.adsType || '';
      }

      data.items.push({
        properties:myPropertiesObj,
        id:id,
        quantity: Selectors.stockActive ? Selectors.stockQuantity : (Selectors.clubCheckboxes.length === 0 ? 1 : Selectors.clubCheckboxes.length)
      })

    })

    if (!Selectors.validate()) return
    console.log('Validation passed.');
    Selectors.loading(true);
    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {'Content-Type': 'application/json'},
    })
      .then(response => response.json())
      .then(data => {
        Selectors.updateMainProductProperty(mainGroupProductKey, redirectUrl);
        Selectors.loading(false);
      })
      .catch((error) => {
        Selectors.loading(false);
        console.log('error', error);
        // if(target){
        //   const errorMsg = `Error: ${error}`;
        //   Selectors.showError(target, errorMsg);
        // }
      })
  },
  validate: function(){
    let validate = false;
    const errors = [];
    let firstError = null;

    Selectors.validGroupOfCheckboxes();
    Selectors.validGroupOfChecked();

    const toggleWrapper = document.querySelector('.toggle-content.active');

    if(toggleWrapper){

      toggleWrapper.querySelectorAll(this.classes.allProductsSelectors).forEach(select => {
        if (select.value == '') {
          Selectors.showError(select);
        } else {
          Selectors.removeError(select);
        }
      });

      toggleWrapper.querySelectorAll(this.classes.requiredCheckboxSelect).forEach(checkbox => {
        if (checkbox.checked == false) {
          console.log(this.classes.requiredCheckboxSelect, 'check')
          Selectors.showError(checkbox, '', '.product-options__checkbox-group-wrapper');
        } else {
          Selectors.removeError(checkbox, '.product-options__checkbox-group-wrapper');
        }
      });

      toggleWrapper.querySelectorAll(this.classes.productOptionItemError).forEach(el => {
        errors.push(el)
      });
      toggleWrapper.querySelectorAll(this.classes.productCheckboxItemError).forEach(el => {
        errors.push(el)
      });
    }
    if(document.querySelector('[data-template="wedges-template"]')) {
      document.querySelectorAll(this.classes.productCheckboxItemError).forEach(el => {
        errors.push(el)
      })
    }


    if (errors.length > 0) {
      firstError = errors[0];
    } else {
      validate = true;
    }

    if (firstError) {
      Selectors.scrollToElement(firstError);
    }
    return validate;
  },

  showError: function(element, message, parentClass){
    const parent = element.closest(parentClass? parentClass : this.classes.productOptionItem);

    parent.classList.add('error');
    if(message) {

      parent.querySelector('.error-message').innerText = message;
      parent.querySelector('.error-message').classList.add('show');
    }
  },
  scrollToElement: function(target){
    target.scrollIntoView({behavior: "smooth", block: "center"});
  },
  removeError: function(element, parentClass){
    const parent = element.closest(parentClass? parentClass : this.classes.productOptionItem);
    const errorMessageBlock = parent.querySelector('.error-message');

    parent.classList.remove('error');

    if (errorMessageBlock) {
      parent.querySelector('.error-message').innerText = '';
      parent.querySelector('.error-message').classList.remove('show');
    }
  },
  validGroupOfCheckboxes: function() {

    document.querySelectorAll(this.classes.groupOfChecbxes).forEach(checkbox => {
      if ($('.group-of-checkboxes :checkbox:checked').length > 0) {
        $('.group-of-checkboxes').removeClass('error')
      } else {
        $('.group-of-checkboxes').addClass('error')
    }
    });
  },
  validGroupOfChecked: function() {

    document.querySelectorAll(this.classes.groupOfChecbxes).forEach(checkbox => {
      if ($('.group-of-checkboxes :checked').length > 0) {
        $('.product-options__checkbox-group-wrapper.checkbox-logo').removeClass('error')
      } else {
        $('.product-options__checkbox-group-wrapper.checkbox-logo').addClass('error')
    }
    });
  },
  defaultVariantChange: function() {
    console.log( document.querySelector(this.classes.currencySymbol).getAttribute('valid-symbol') , 'document.querySelector(this.classes.currencySymbol) ')
    const variants = document.querySelectorAll(this.classes.variantOptions);
    const quantityField = document.querySelector(this.classes.quantityInput);
    const priceHolders = document.querySelectorAll(this.classes.priceHolder);
    const symbol = document.querySelector(this.classes.currencySymbol)

    if (!variants || !quantityField) {
      return;
    }
    variants.forEach(variant => {
      variant.addEventListener('change', function(e) {
        const quantity = parseInt(quantityField.value);
        const selectedOption = variant.options[variant.selectedIndex];
        const price = parseFloat(selectedOption.getAttribute('data-price'));

        if (!isNaN(price) && !isNaN(quantity)) {
          const newPrice = price * quantity;

          priceHolders.forEach(priceHolder => {
            priceHolder.dataset.summPrices = newPrice;
            priceHolder.innerHTML = Shopify.formatMoney(newPrice,  `${symbol.getAttribute('valid-symbol')} {{amount}}`);
          });
        }

      })
    })
  },
  quantityChange: function() {
    const variants = document.querySelector('select.default-variants');
    const quantityBtns = document.querySelectorAll(this.classes.quantityBtns);
    const priceHolders = document.querySelectorAll(this.classes.priceHolder);
    const quantityField = document.querySelector(this.classes.quantityInput);
    const symbol = document.querySelector(this.classes.currencySymbol)

    if (!quantityField ) {
      return;
    }

    quantityBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        const currentQuantity = parseInt(quantityField.value);
        const dataQuantity = btn.getAttribute('data-quantity');
        const selectedOption = variants.options[variants.selectedIndex]
        const price = parseFloat(selectedOption.getAttribute('data-price'));

        if (!isNaN(currentQuantity)) {
          if (dataQuantity === 'plus') {
            quantityField.value = currentQuantity + 1;
          } else if (dataQuantity === 'minus') {
            if (currentQuantity > 1) {
              quantityField.value = currentQuantity - 1;
            }
          }

          if (quantityField.value === '1') {
            document.querySelector('[data-quantity="minus"]').setAttribute('disabled', 'disabled');
          } else {
            document.querySelector('[data-quantity="minus"]').removeAttribute('disabled');
          }

          priceHolders.forEach(priceHolder => {
            priceHolder.dataset.summPrices = price * quantityField.value;
            priceHolder.innerHTML = Shopify.formatMoney(price * quantityField.value,  `${symbol.getAttribute('valid-symbol')} {{amount}} `);
          });

        }
      });
    });

    if (quantityField.value === '1') {
      document.querySelector('[data-quantity="minus"]').setAttribute('disabled', 'disabled');
    }
  },
  toggleVariants: function(){
    const variantSelectors = document.querySelectorAll(this.classes.variantButton);
    const defaultSelectorsWrapper = document.querySelectorAll(this.classes.defaultSelectorsWrapper);

    variantSelectors.forEach(selector => {

      selector.addEventListener('change', function(e){
        const selectedValue = e.target.defaultValue || $( ".select-variant option:selected" ).val();

        if(!selectedValue && selectedValue == 'undefined' && !defaultSelectorsWrapper) return
        defaultSelectorsWrapper.forEach(select => {
          const currentSelector = select.querySelector('select')
          for (var option of currentSelector.options) {
            if(selectedValue === option.value){
              currentSelector.value = option.value;
              // currentSelector.dispatchEvent(new Event("change"))
            }
          }
        })
        Selectors.toogleMainProductSelect()
      })
    });
  },
  toogleMainProductSelect: function (params) {
    const defaultVariantSelectors = document.querySelectorAll(this.classes.defaultSelectorsWrapper);
    const defaultProductFormSelectors = document.querySelectorAll('select.product-form__variants');
    const selectedValues = [];

    defaultVariantSelectors.forEach(selector => {
        if (selector.querySelector('select').value) {
            selectedValues.push(selector.querySelector('select').value)
        }
    });

    defaultProductFormSelectors.forEach(defaultProductFormSelector => {
        for (let option of defaultProductFormSelector.options) {
            if (option.text.includes(' / ')) {
                const buildedOptionValue = selectedValues.join(' / ');
                if (buildedOptionValue === option.text) {
                    defaultProductFormSelector.value = option.value;
                    defaultProductFormSelector.dispatchEvent(new Event("change"));
                }
            } else {
                if (selectedValues.every(value => value === option.text)) {
                    defaultProductFormSelector.value = option.value;
                    defaultProductFormSelector.dispatchEvent(new Event("change"));
                }
            }
        }
    });
},
  init: function(){
    const validColor = document.querySelector('.product-slider .swiper-slide-active .img').alt
    console.log('Init Product Selectors');
    this.toggleVariants();
    this.addToCartButton();
    this.onRelatedProductChange();
    this.clearInputs();
    this.toggleContent();
    this.onRelatedVariantChange();
    this.hideImagesByAlt(validColor);
    this.onStockCheckboxChange();
    // this.onRelatedSingleProductPrice();
    this.onPropertieSelectChange();
    this.onPropertieInputChange();
    this.onPropertiesAreaChange();
    this.onSelectAdaptorModelChange();
    this.onPropertieRadioChange();
    this.onRequiredCheckboxChange();
    this.onProductCheckboxChange();
    this.onMultipleCheckboxChange();
    this.calculateMultipleCheckboxes();
    // this.buildVariantsSwatches();
    this.changePrice();
    this.quantityChange()
    this.defaultVariantChange()
    this.onColorsChangeSlides();
    this.onRelatedVariantsChange();
    buildVariantsSwatches('.product-options__container');
  }
}
window.addEventListener('DOMContentLoaded', (event) => {

  const symbolElement = document.querySelector('localization-form .localization-form__button')
  const symbol = symbolElement.getAttribute('valid-symbol')

  if(symbol != 'USD' ){
    fetch(`/cart.js`, {
      method: 'POST',
      body: JSON.stringify({currency:  symbol }),
      headers: { 'Content-Type': 'application/json' },
    })
  }

  let selected_variant = $('[name="id"]').val();
  let slider = $('.product-slider .swiper-wrapper .img');
  const input = document.querySelector('.color-swatch input[type="radio"]:checked');
  const thumbnails = document.querySelectorAll('.product-slider-nav .image__dots');
if(input) {
  thumbnails.forEach(thumbnail => {
    const slide = thumbnail.closest('.swiper-slide');
    const altValue = thumbnail.getAttribute('alt');

    if (altValue && altValue == input.value) {
      slide.style.display = '';
    } else {
      slide.style.display = 'none';
    }
  });
}
  let current_variant = Array.from(slider).findIndex(item => item.getAttribute('data-variant-id').split(',').includes(selected_variant));
  document.variantImageSlider.slideTo(current_variant, 0, false);

  var paymentTerms = document.querySelector('shopify-payment-terms')

  if(paymentTerms) { 
    function updateBannerWhenEligible() {
      if (paymentTerms.currentBanner && paymentTerms.currentBanner.eligible === true) {
        paymentTerms.currentBanner.eligible = false;
        paymentTerms.currentBanner.updateBannerPrice();
        paymentTerms.currentBanner.updateLearnMoreButtonAndModal();
      }
    }

    var eligibilityCheckInterval = setInterval(function() {
      updateBannerWhenEligible();
    }, 100);

    setTimeout(function() {
      clearInterval(eligibilityCheckInterval);
    }, 1000);
  }
  if(document.querySelector('.explore-btn') != null) {
    const popupBtn = document.querySelector('.explore-btn');
    const popup = document.getElementById('popup');

    popupBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      document.body.classList.add('popup-open');
      popup.style.display = 'block';
    });

    document.addEventListener('click', (e) => {
      if (!popup.contains(e.target) && e.target !== popup && e.target !== popupBtn) {
        document.body.classList.remove('popup-open');
        popup.style.removeProperty('display');
      }
    });

    popup.addEventListener('click', (e) => {
      if (e.target.classList.contains('popup-close') | e.target.classList.contains('icon-close')) {
        document.body.classList.remove('popup-open');
        popup.style.removeProperty('display');
      }
    });
  }
  Selectors.init()
});
